import { BuildPCV2Provider } from 'contexts';
import { BuildPC } from 'modules/buildpc/desktop';
import { getServerSidePropsBuildPC } from 'modules/buildpc/shared';
import { PbPageProps } from 'modules/page-builder';
import React from 'react';

const BuildPcPage: React.FunctionComponent<PbPageProps> = (props) => {
  return (
    <BuildPCV2Provider>
      <BuildPC {...props} />
    </BuildPCV2Provider>
  );
};

export const getServerSideProps = getServerSidePropsBuildPC;

export default BuildPcPage;
